import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'antd'
import '../style/DesktopMedicalHistory.css'
import MedicalHistoryFormTemplates from '../../utils/templates'
import DesktopMedicalHistoryForm from './DesktopMedicalHistoryForm'
// Import new desktop section components
import DesktopAllergies from './DesktopAllergies'
import DesktopMedicalHistoryLoadingOverlay from './LoadingOverlay'

const DesktopMedicalHistory = ({ loading }) => {
  const [currentSection, setCurrentSection] = useState(null)
  const [fieldValues, setFieldValues] = useState(MedicalHistoryFormTemplates.dataTemplate)
  const [form] = Form.useForm()
  const patMedicalHistory = useSelector((state) => state.patMedHist.data) || {}

  if (loading) {
    return <DesktopMedicalHistoryLoadingOverlay text='Loading Medical History...' loading={loading} />
  }

  return (
    <div className='desktop-medical-history-container'>
      {currentSection ? (
        <Form
          form={form}
          className='desktop-medical-history-content'
          initialValues={fieldValues}
          onValuesChange={(_, allValues) => {
            const updatedValues = {
              ...patMedicalHistory,
              ...allValues
            }
            setFieldValues(updatedValues)
          }}
          preserve={true}
        >
          <DesktopAllergies clientForm={form} loading={loading} setFacet={setCurrentSection} />
        </Form>
      ) : (
        <div className='desktop-medical-history-main'>
          <DesktopMedicalHistoryForm
            data={patMedicalHistory}
            setMedicalHistory={patMedicalHistory}
            fieldValues={fieldValues}
            onSelectSection={patMedicalHistory}
          />
        </div>
      )}
    </div>
  )
}

export default DesktopMedicalHistory
